export const toTree = function (list, parentId = 0) {
    let parentObj = {};
    list.forEach(o => {
        parentObj[o.actionId] = o;
    })
    if (!parentId) {
        return list.filter(o => !parentObj[o.parentId]).map(o => {
            o.children = toTree(list, o.actionId)
            return o
        })
    } else {
        return list.filter(o => o.parentId == parentId).map(o => {
            o.children = toTree(list, o.actionId)
            return o
        }
        );
    }
}